import { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { showSuccess } from '../../0_presentation/core/components/feedback/snackbar';
import { Client } from '../../2_domain/client/client';
import IClientRepository from '../../2_domain/client/iClientRepository';
import IClinicRepository from '../../2_domain/clinic/iClinicRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const useClientRegisterPageController = () => {
  const clientRepo = Get.find<IClientRepository>('IClientRepository');
  const clinicRepo = Get.find<IClinicRepository>('IClinicRepository');
  const theme = useTheme();
  const [step, setStep] = useState(0);
  const client = useRef<Client | undefined>();
  const [isClientValid, setIsClientValid] = useState(false);
  const [clinicSerial, setClinicSerial] = useState('');

  const toNext = async () => {
    setStep((prev) => prev + 1);
  };

  const toPrev = async () => {
    setStep((prev) => prev - 1);
  };

  const setClient = (
    newClient: Client | ((client: Client | undefined) => Client)
  ): void => {
    if (typeof newClient === 'function') {
      client.current = newClient(client.current);
    } else {
      client.current = newClient;
    }
  };

  const onSaveHandler = async () => {
    if (client.current) {
      await promiseResolver({
        promise: clientRepo.createClient(client.current),
        successCallback: () => {
          showSuccess(theme.texts.clientAddSuccess);
          setIsClientValid(false);
          client.current = undefined;
          setStep(0);
        },
      });
    }
  };

  useEffect(() => {
    promiseResolver({
      promise: clinicRepo.getClinicInformation(),
      successCallback: (data) => {
        setClinicSerial(data.serial);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    step,
    client,
    setClient,
    canNext: !isClientValid,
    setIsClientValid,
    toNext,
    toPrev,
    onSaveHandler,
    clinicSerial,
  };
};

export default useClientRegisterPageController;
